import { Price } from 'src/types';
import { IProductCondition } from './types';
import { FilterType, IFilter } from 'src/components/price-list/types';
import { TranslateFunc } from 'src/components/translate';

export const getCondition = (
  name: 'new' | 'used',
  count: number
): IProductCondition => {
  return {
    name,
    from: 0,
    to: 0,
    count,
  };
};

export const getProductConditionValues = (
  offers: Price[]
): IProductCondition[] => {
  const usedOffers = offers.filter(x => x.condition !== 'new');
  const newOffers = offers.filter(x => x.condition === 'new');

  if (!usedOffers.length) {
    return [];
  }

  const conditionList: IProductCondition[] = [];
  conditionList.push(getCondition('new', newOffers.length));
  conditionList.push(getCondition('used', usedOffers.length));
  return conditionList;
};

export const resetVariantFilters = (filters: IFilter[]): IFilter[] => {
  const variantFilterTypes = [
    FilterType.VARIANT_SIZE,
    FilterType.VARIANT_COLOR,
  ];
  const updatedFilters = filters
    .filter(filter => variantFilterTypes.includes(filter.type))
    .map(filter => {
      return { ...filter, active: false, selection: [] };
    });
  return updatedFilters;
};

export const getConditionName = (
  type: 'new' | 'used',
  t: TranslateFunc
): string => {
  if (type === 'used') {
    return t('product', 'price-filter.used-short');
  }
  return t('product', 'price-filter.new');
};
